(function ($) {
    'use strict';

    window.dataLayer = window.dataLayer || [];

    var startedForms = {};
    var viewedForms = {};

    function getFormTitle(formId) {
        var form = document.getElementById('gform_' + formId);
        if (!form) return '';
        var heading = form.querySelector('h2, h3, .gform_title');
        return heading ? heading.textContent.trim() : 'Form ' + formId;
    }

    function getStoredFormName(formId) {
        try {
            return localStorage.getItem('gf_form_name_' + formId) || '';
        } catch (e) {
            return '';
        }
    }

    function storeFormName(formId, name) {
        try {
            if (name) localStorage.setItem('gf_form_name_' + formId, name);
        } catch (e) {}
    }

    function captureFields(formId) {
        var form = document.getElementById('gform_' + formId);
        if (!form) return [];

        var fields = [];

        form.querySelectorAll('.gfield').forEach(function (gfield) {
            var labelEl = gfield.querySelector('.gfield_label');
            var label = labelEl ? labelEl.textContent.trim().replace(/\s*\*\s*$/, '') : '';

            // Text-like inputs
            var textInput = gfield.querySelector(
                'input[type="text"], input[type="email"], input[type="tel"],' +
                'input[type="number"], input[type="url"], textarea'
            );
            if (textInput && textInput.value.trim()) {
                var val = textInput.value.trim();
                var isNameField = /^namn$|^name$/i.test(label);
                if (isNameField && val.indexOf(' ') !== -1) {
                    var spaceIdx = val.indexOf(' ');
                    fields.push({ label: 'Förnamn', value: val.substring(0, spaceIdx) });
                    fields.push({ label: 'Efternamn', value: val.substring(spaceIdx + 1).trim() });
                } else {
                    fields.push({ label: label, value: val });
                }
                return;
            }

            // Select
            var select = gfield.querySelector('select');
            if (select && select.value) {
                fields.push({ label: label, value: select.options[select.selectedIndex].text });
                return;
            }

            // Checkboxes (may have multiple checked)
            var checked = gfield.querySelectorAll('input[type="checkbox"]:checked');
            if (checked.length) {
                var values = [];
                checked.forEach(function (cb) {
                    var cbLabel = gfield.querySelector('label[for="' + cb.id + '"]');
                    values.push(cbLabel ? cbLabel.textContent.trim() : cb.value);
                });
                fields.push({ label: label, value: values.join(', ') });
                return;
            }

            // Radio
            var radio = gfield.querySelector('input[type="radio"]:checked');
            if (radio) {
                var radioLabel = gfield.querySelector('label[for="' + radio.id + '"]');
                fields.push({ label: label, value: radioLabel ? radioLabel.textContent.trim() : radio.value });
            }
        });

        return fields;
    }

    function storeFields(formId, fields) {
        try {
            sessionStorage.setItem('gf_form_fields_' + formId, JSON.stringify(fields));
        } catch (e) {}
    }

    function getStoredFields(formId) {
        try {
            return JSON.parse(sessionStorage.getItem('gf_form_fields_' + formId)) || [];
        } catch (e) {
            return [];
        }
    }

    function pushEvent(eventName, formId, extraFields) {
        var name = getFormTitle(formId) || getStoredFormName(formId);
        var payload = {
            event: eventName,
            form_id: formId,
            form_name: name,
        };
        if (extraFields && extraFields.length) {
            payload.form_fields = extraFields;
        }
        window.dataLayer.push(payload);
    }

    function trackFormView(formId) {
        if (viewedForms[formId]) return;
        var form = document.getElementById('gform_' + formId);
        var hasErrors = form && form.querySelector('.gfield_error');
        viewedForms[formId] = true;
        storeFormName(formId, getFormTitle(formId));
        pushEvent(hasErrors ? 'form_error' : 'form_view', formId);
    }

    function bindStartTracking(formId) {
        if (startedForms[formId]) return;
        var form = document.getElementById('gform_' + formId);
        if (!form) return;

        $(form).find('input, textarea, select').one('focus', function () {
            if (!startedForms[formId]) {
                startedForms[formId] = true;
                pushEvent('form_start', formId);
            }
        });

        // Capture field values on submit (before page reload for non-AJAX forms)
        $(form).on('submit', function () {
            storeFields(formId, captureFields(formId));
        });
    }

    $(function () {
        $('.gform_wrapper[id]').each(function () {
            var match = this.id.match(/^gform_wrapper_(\d+)$/);
            if (match) {
                var formId = parseInt(match[1], 10);
                trackFormView(formId);
                bindStartTracking(formId);
            }
        });

        // Non-AJAX confirmation page: retrieve stored fields from sessionStorage
        $('[id^="gform_confirmation_wrapper_"]').each(function () {
            var match = this.id.match(/^gform_confirmation_wrapper_(\d+)$/);
            if (match) {
                var formId = parseInt(match[1], 10);
                pushEvent('form_submit', formId, getStoredFields(formId));
                sessionStorage.removeItem('gf_form_fields_' + formId);
            }
        });
    });

    $(document).on('gform_post_render', function (event, formId) {
        trackFormView(formId);
        bindStartTracking(formId);
    });

    // AJAX confirmation: form is still in DOM, capture directly
    $(document).on('gform_confirmation_loaded', function (event, formId) {
        pushEvent('form_submit', formId, captureFields(formId));
        delete startedForms[formId];
        delete viewedForms[formId];
        sessionStorage.removeItem('gf_form_fields_' + formId);
    });

}(jQuery));

//# sourceMappingURL=gravity-forms-datalayer.js.map
